<div *ngIf="showBrowserRefreshMessage" class="browser-refresh-message">
    A new version is available. <a class="emerald cursor-pointer" (click)="refreshBrowser()">REFRESH</a>
</div>